
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/joinOEA",
      function () {
        return require("private-next-pages/[lang]/joinOEA.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/joinOEA"])
      });
    }
  